import React, { useRef, useEffect, useState, useMemo } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { uniqBy } from 'lodash';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { customStyles } from '../../helper';
import OutsideAlerterwithClassName from '../OutsideAlerter/OutsideAlerterwithClassName';
import * as supplierAction from '../../../Pages/Supplier/store/Supplier.action';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import * as masterAction from '../../../Pages/SystemMasters/Store/SystemMasters.action';

/** Shared filter styles, with the fixed 40px control height relaxed so multi-select chips can wrap. */
const multiSelectStyles = {
  ...customStyles,
  control: (provided, state) => ({
    ...customStyles.control(provided, state),
    height: 'auto',
    minHeight: '40px',
    flexWrap: 'wrap',
  }),
};

function ComponentFilter({
  onBtnClick,
  placeholder,
  noOption,
  placeholder2,
  noOption2,
  placeholder3,
  noOption3,
  placeholder4,
  noOption4,
  placeholder5,
  noOption5,
  placeholder6,
  placeholder7,
  placeholderPT,
  placeholder8,
  placeholder9,
  placeholder10,
  placeholder11,
  noOption6,
  noOption7,
  noOptionPT,
  noOption8,
  noOption9,
  noOption10,
  noOption11,
  selectedItem1,
  selectedItem2,
  selectedItem3,
  selectedItem4,
  selectedItem5,
  selectedItem6,
  selectedItem7,
  selectedItemPT,
  selectedItem8,
  selectedItem9,
  selectedItem10,
  selectedItem11,
  productSupplierOptions,
  selectedProductSupplier,
  placeholderPS,
  noOptionPS,
  inFilter,
}) {
  const triggerRef = useRef(null);
  const dispatch = useDispatch();
  const ProductTestingData = useSelector((redState) => redState);
  const { SystemMastersDetails, BomLibraryDetails, SuppliersDetails, UserDetails } = ProductTestingData;
  const { finalList, brandList, category3List, category4List, category2List, category1List, subBrandAccess, multiSubBrandList } = SystemMastersDetails;
  const { tier1List, tier2AndAboveList } = SuppliersDetails;
  const { ReferenceType, Composition, userList } = BomLibraryDetails;
  const { pcTypeList } = SystemMastersDetails;
  const { userInfo, isSupplierLoggedIn } = UserDetails;
  const loggedInUserId = userInfo.userId;
  const userRole = userInfo.role;
  const [referenceSupp, setReferenceSupp] = useState([]);
  const [userArray, setUserArray] = useState([]);
  const [show, setShow] = useState(false);
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(masterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  // Derived cascading options based on flag and selections within the filter
  const selectedPTId = useMemo(() => selectedItemPT?._id || null, [selectedItemPT]);
  const selectedCat1Id = useMemo(() => selectedItem7?._id || null, [selectedItem7]);
  const selectedCat2Id = useMemo(() => selectedItem8?._id || null, [selectedItem8]);
  const selectedCat3Id = useMemo(() => selectedItem9?._id || null, [selectedItem9]);

  const category1Derived = useMemo(() => {
    if (!catBasedOnPTData) return category1List || [];
    if (!selectedPTId) return category1List || [];
    return (category1List || []).filter((c1) => {
      const pts = c1?.productType || [];
      const arr = Array.isArray(pts) ? pts : [pts];
      const ids = arr.map((x) => x?._id || x).filter(Boolean);
      return ids.includes(selectedPTId);
    });
  }, [catBasedOnPTData, selectedPTId, category1List]);

  const category2Derived = useMemo(() => {
    if (!catBasedOnPTData) return category2List || [];
    if (!selectedCat1Id) return category2List || [];
    return (category2List || []).filter((c2) => {
      const rel = c2?.categoryOneId || c2?.catOneIds || [];
      const arr = Array.isArray(rel) ? rel : [rel];
      const ids = arr.map((x) => x?._id || x).filter(Boolean);
      return ids.includes(selectedCat1Id);
    });
  }, [catBasedOnPTData, selectedCat1Id, category2List]);

  const category3Derived = useMemo(() => {
    if (!catBasedOnPTData) return category3List || [];
    if (!selectedCat1Id || !selectedCat2Id) return [];
    return (category3List || []).filter((c3) => {
      const r1 = c3?.categoryOneId || c3?.catOneIds || [];
      const r2 = c3?.categoryTwoId || c3?.catTwoIds || [];
      const a1 = (Array.isArray(r1) ? r1 : [r1]).map((x) => x?._id || x).filter(Boolean);
      const a2 = (Array.isArray(r2) ? r2 : [r2]).map((x) => x?._id || x).filter(Boolean);
      return a1.includes(selectedCat1Id) && a2.includes(selectedCat2Id);
    });
  }, [catBasedOnPTData, selectedCat1Id, selectedCat2Id, category3List]);

  useEffect(() => {
    try {
      dispatch(
        masterAction.getPCTypesDetails({
          loggedInUserId: userInfo?.userId,
          isActive: true,
          tier: 'Tier1',
        }),
      );
    } catch (e) {
      // no-op
    }
  }, [dispatch, userInfo?.userId]);
  useEffect(() => {
    const apiCall = async () => {
      let rs = [];

      if (tier2AndAboveList?.length > 0 || tier1List?.length > 0) {
        const rsArray = uniqBy([...tier1List, ...tier2AndAboveList], 'name');
        const unique_rs = [];
        const unique_rsArray = [];
        rsArray.forEach((val) => {
          if (unique_rs.indexOf(val._id) === -1) {
            unique_rs.push(val._id);
            unique_rsArray.push(val);
          }
        });
        rs.push(...unique_rsArray);
        rs.forEach((ele) => {
          ele.label = ele.name;
          ele.value = ele._id;
        });
        if (userRole === 'User') {
          const userSuppliers = await dispatch(supplierAction.fetchUserSuppliers({ userId: loggedInUserId }));
          if (Array.isArray(userSuppliers)) {
            rs = rs.filter((val) => {
              if (userSuppliers.includes(val._id)) return val;
            });
          }
        }
        setReferenceSupp(rs);
      }
    };
    apiCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tier2AndAboveList, tier1List]);

  useEffect(() => {
    const arr = [userInfo, ...userList];
    arr.forEach((ele) => (ele.name = `${ele.firstName} ${ele.lastName}`));
    setUserArray([...arr]);
  }, [userList, userInfo]);

  const handleSubmit = () => {
    setShow(false);
    onBtnClick();
  };

  const handleShow = () => {
    setShow(!show);
  };

  const handleOutSideClickToSideBar = () => {
    setShow(false);
  };

  const resetFilters = () => {
    setShow(false);
    onBtnClick('clear');
  };

  const { t } = useTranslation('common');

  return (
    <div className="modified-popOver bom_filter_btn">
      <CustomTooltip placement="top" tooltipText={t('COMPONENET_FILTER.FILTER')}>
        <button type="button" onClick={handleShow} aria-label="filter" className={inFilter ? 'btn d-inline-flex pr-0 active' : 'btn d-inline-flex pr-0'}>
          <OverlayTrigger
            placement={t('COMPONENET_FILTER.BUTTON')}
            trigger="click"
            rootClose
            show={show}
            target={triggerRef}
            overlay={
              <Popover className="custom-popover bom-Library-Filter">
                <OutsideAlerterwithClassName handleOutSideClick={handleOutSideClickToSideBar} classItem="icon-Filter">
                  <Popover.Content>
                    <Row className="form-row">
                      {productSupplierOptions?.length > 0 && (
                        <Col xs={6} md={3}>
                          <FormGroup className="flex-fill">
                            <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                              <Select
                                isMulti
                                isClearable
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                options={productSupplierOptions}
                                maxMenuHeight={132}
                                menuPlacement="bottom"
                                menuPosition="relative"
                                getOptionLabel={(optionPS) => `${optionPS.name}`}
                                getOptionValue={(optionPS) => `${optionPS._id}`}
                                onChange={(e) => onBtnClick('productSupplier', e)}
                                styles={multiSelectStyles}
                                value={selectedProductSupplier}
                                placeholder={placeholderPS}
                                noOptionsMessage={() => noOptionPS}
                                className="common-select"
                                classNamePrefix="common-select"
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      )}
                      {!isSupplierLoggedIn && (
                        <Col xs={6} md={3}>
                          <FormGroup className="flex-fill ">
                            <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                              <Select
                                isClearable
                                options={referenceSupp}
                                maxMenuHeight={132}
                                menuPlacement="bottom"
                                menuPosition="relative"
                                getOptionLabel={(opt) => `${opt.name}`}
                                getOptionValue={(opt) => `${opt._id}`}
                                onChange={(e) => onBtnClick('op1', e)}
                                styles={customStyles}
                                value={selectedItem1}
                                placeholder={placeholder}
                                noOptionsMessage={() => noOption}
                                className="common-select"
                                classNamePrefix="common-select"
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      )}
                      <Col xs={6} md={3}>
                        <FormGroup className="flex-fill">
                          <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                            <Select
                              isClearable
                              options={ReferenceType}
                              maxMenuHeight={132}
                              menuPlacement="bottom"
                              menuPosition="relative"
                              getOptionLabel={(option2) => `${option2.name}`}
                              getOptionValue={(option2) => `${option2._id}`}
                              onChange={(event) => onBtnClick('op2', event)}
                              styles={customStyles}
                              value={selectedItem2}
                              placeholder={placeholder2}
                              noOptionsMessage={() => noOption2}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col xs={6} md={3}>
                        <FormGroup className="flex-fill">
                          <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                            <Select
                              isClearable
                              options={finalList}
                              maxMenuHeight={132}
                              menuPlacement="bottom"
                              menuPosition="relative"
                              getOptionLabel={(option3) => `${option3.name}`}
                              getOptionValue={(option3) => `${option3._id}`}
                              onChange={(event) => onBtnClick('op3', event)}
                              styles={customStyles}
                              value={selectedItem3}
                              placeholder={placeholder3}
                              noOptionsMessage={() => noOption3}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col xs={6} md={3}>
                        <FormGroup className="flex-fill">
                          <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                            <Select
                              isClearable
                              options={Composition}
                              maxMenuHeight={132}
                              menuPlacement="bottom"
                              menuPosition="relative"
                              getOptionLabel={(option4) => `${option4.name}`}
                              getOptionValue={(option4) => `${option4._id}`}
                              onChange={(e) => onBtnClick('op4', e)}
                              styles={customStyles}
                              value={selectedItem4}
                              placeholder={placeholder4}
                              noOptionsMessage={() => noOption4}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      {!isSupplierLoggedIn && (
                        <Col xs={6} md={3}>
                          <FormGroup className="flex-fill">
                            <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                              <Select
                                isClearable
                                options={userArray}
                                maxMenuHeight={132}
                                menuPlacement="bottom"
                                menuPosition="relative"
                                getOptionLabel={(option5) => `${option5.name}`}
                                getOptionValue={(option5) => `${option5._id}`}
                                onChange={(e) => onBtnClick('op5', e)}
                                styles={customStyles}
                                value={selectedItem5}
                                placeholder={placeholder5}
                                noOptionsMessage={() => noOption5}
                                className="common-select"
                                classNamePrefix="common-select"
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      )}
                      <Col xs={6} md={3}>
                        <FormGroup className="flex-fill">
                          <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                            <Select
                              isClearable
                              options={brandList}
                              maxMenuHeight={132}
                              menuPlacement="bottom"
                              menuPosition="relative"
                              getOptionLabel={(option6) => `${option6.name}`}
                              getOptionValue={(option6) => `${option6._id}`}
                              onChange={(e) => onBtnClick('op6', e)}
                              styles={customStyles}
                              value={selectedItem6}
                              placeholder={placeholder6}
                              noOptionsMessage={() => noOption6}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      {subBrandAccess && (
                        <Col xs={6} md={3}>
                          <FormGroup className="flex-fill">
                            <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                              <Select
                                isClearable
                                options={multiSubBrandList || []}
                                maxMenuHeight={132}
                                menuPlacement="bottom"
                                menuPosition="relative"
                                getOptionLabel={(option11) => `${option11.name}`}
                                getOptionValue={(option11) => `${option11._id}`}
                                onChange={(e) => onBtnClick('op11', e)}
                                styles={customStyles}
                                value={selectedItem11}
                                placeholder={placeholder11}
                                noOptionsMessage={() => noOption11}
                                className="common-select"
                                classNamePrefix="common-select"
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      )}
                      {catBasedOnPTData && (
                        <Col xs={6} md={3}>
                          <FormGroup className="flex-fill">
                            <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                              <Select
                                isClearable
                                options={pcTypeList}
                                maxMenuHeight={132}
                                menuPlacement="bottom"
                                menuPosition="relative"
                                getOptionLabel={(option6) => `${option6.name}`}
                                getOptionValue={(option6) => `${option6._id}`}
                                onChange={(e) => onBtnClick('productType', e)}
                                styles={customStyles}
                                value={selectedItemPT}
                                placeholder={placeholderPT || 'Select ProductType'}
                                noOptionsMessage={() => noOptionPT}
                                className="common-select"
                                classNamePrefix="common-select"
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      )}
                      <Col xs={6} md={3}>
                        <FormGroup className="flex-fill">
                          <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                            <Select
                              isClearable
                              options={catBasedOnPTData ? category1Derived : category1List}
                              maxMenuHeight={132}
                              menuPlacement="bottom"
                              menuPosition="relative"
                              getOptionLabel={(option7) => `${option7.name}`}
                              getOptionValue={(option7) => `${option7._id}`}
                              onChange={(e) => onBtnClick('op7', e)}
                              styles={customStyles}
                              value={selectedItem7}
                              placeholder={placeholder7}
                              noOptionsMessage={() => noOption7}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col xs={6} md={3}>
                        <FormGroup className="flex-fill">
                          <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                            <Select
                              isClearable
                              options={catBasedOnPTData ? category2Derived : category2List}
                              maxMenuHeight={132}
                              menuPlacement="bottom"
                              menuPosition="relative"
                              getOptionLabel={(option8) => `${option8.name}`}
                              getOptionValue={(option8) => `${option8._id}`}
                              onChange={(e) => onBtnClick('op8', e)}
                              styles={customStyles}
                              value={selectedItem8}
                              placeholder={placeholder8}
                              noOptionsMessage={() => noOption8}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col xs={6} md={3}>
                        <FormGroup className="flex-fill">
                          <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                            <Select
                              isClearable
                              options={catBasedOnPTData ? category3Derived : category3List}
                              maxMenuHeight={132}
                              menuPlacement="bottom"
                              menuPosition="relative"
                              getOptionLabel={(option9) => `${option9.name}`}
                              getOptionValue={(option9) => `${option9._id}`}
                              onChange={(e) => onBtnClick('op9', e)}
                              styles={customStyles}
                              isDisabled={!selectedItem8 && !selectedItem7}
                              value={selectedItem9}
                              placeholder={placeholder9}
                              noOptionsMessage={() => noOption9}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col xs={6} md={3}>
                        <FormGroup className="flex-fill">
                          <div onClick={(e) => e.stopPropagation()} className="common-react-select mb-0 flex-fill">
                            <Select
                              isClearable
                              options={category4List}
                              maxMenuHeight={132}
                              menuPlacement="bottom"
                              menuPosition="relative"
                              getOptionLabel={(option10) => `${option10.name}`}
                              getOptionValue={(option10) => `${option10._id}`}
                              onChange={(e) => onBtnClick('op10', e)}
                              isDisabled={!selectedItem8 && !selectedItem7 && !selectedItem9}
                              styles={customStyles}
                              value={selectedItem10}
                              placeholder={placeholder10}
                              noOptionsMessage={() => noOption10}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div className=" d-flex justify-content-end">
                          <div className="">
                            <CustomTooltip placement="top" tooltipText={t('COMPONENET_FILTER.CLEAR')}>
                              <button aria-label="clear" type="button" onClick={resetFilters} id="Clear" className="btn p-0">
                                <i className="icon-Clear-New f-24" />
                              </button>
                            </CustomTooltip>
                            <CustomTooltip placement="top" tooltipText={t('COMPONENET_FILTER.APPLY')}>
                              <button aria-label="apply" type="submit" onClick={handleSubmit} id="Apply" className="btn ml-16 p-0">
                                <i className="icon-Tick-1 f-28" />
                              </button>
                            </CustomTooltip>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Popover.Content>
                </OutsideAlerterwithClassName>
              </Popover>
            }
          >
            <i className="icon-Filter f-26" />
          </OverlayTrigger>
        </button>
      </CustomTooltip>
    </div>
  );
}

export default ComponentFilter;
